import { render, staticRenderFns } from "./PatientPage.vue?vue&type=template&id=2602fc20&scoped=true&"
import script from "./PatientPage.vue?vue&type=script&lang=js&"
export * from "./PatientPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2602fc20",
  null
  
)

export default component.exports